import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import { AutosuggestService } from '../autosuggest.service';
import { environment } from '../../environments/environment';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-customer-schedular',
  templateUrl: './customer-schedular.component.html',
  styleUrls: ['./customer-schedular.component.css']
})
export class CustomerSchedularComponent implements OnInit {

  uploadDir: string = environment.uploadDir;
  @ViewChild('fileInput') fileInput;
  selectedOption: string;
  uploads_name: any = {};
  model: any;
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {
    cert_details: []
  };
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  savecertList: any;
  fieldName: string;
  fileList: FileList;
  certId: any;
  fileU: boolean;
  formedata: FormData;
  onlyview: boolean = false;
  options: any;
  getuintofmeasurement: any;
  formdata: FormData;
  upname: any;
  targetfile: any;
  Emp_Id: any;
  headerLabel: string;
  appSug: any = {};
  date: any;
  model1: any = {};
  appSug1: { f_name: string; };
  scheduler_id: any;
  dataresult: any;
  EMPS: any;
  minDateTime: string;
  durHours: number = 1;
  durMins: number = 0;
  activeHours: number = 0;
  activeMins: number = 0;
  hourOptions: number[] = [0,1,2,3,4,5,6,7,8];
  minuteOptions: number[] = [0,5,10,15,20,25,30,35,40,45,50,55];

  // Multi-service rows
  serviceRows: any[] = [];

  defaultRow() {
    return { service: '', employeeIds: [], durHours: 1, durMins: 0, duration_minutes: 60, activeHours: 0, activeMins: 0, employee_active_minutes: 0 };
  }
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _arout: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService,
    private datePipe: DatePipe

  ) {

    this.model = {
      // scheduled_date: '2024-03-27T11:33:00.000Z'
    }
    this.uploads_name.inventory_manager_upload_path = {
      file_name: '',
      file_temp_name: '',
    };
    this.initVar();
    this.appSug = { lname: '' };
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.serviceRows = [this.defaultRow()];
  }

  ngOnInit(): void {
    this.setMinDateTime('');
    this.date = new Date();

    // Read route params FIRST, then load dependencies
    this._arout.params.subscribe(p => {
      if (p.view_id) {
        this.onlyview = true;
      }
      if (p.scheduler_id) {
        this.headerLabel = 'Edit';
        this.scheduler_id = p.scheduler_id;
      }

      // Load services and employees in parallel, then load edit data once both are ready
      const svcDone$ = this.loginservice.getservicecategory('', '1', this.currentUser);
      const empDone$ = this.loginservice.getemp('', this.currentUser);

      Observable.forkJoin(svcDone$, empDone$).subscribe(
        ([svcData, empData]) => {
          // Services
          this.dataresult = (svcData['comp_details'] && svcData['comp_details'].length > 0)
            ? svcData['comp_details'] : [];

          // Employees
          this.EMPS = (empData['comp_details'] && empData['comp_details'].length > 0)
            ? empData['comp_details'] : [];

          if (!this.scheduler_id) {
            // New mode — reset model cleanly
            this.model = { customer_description: '' };
            this.model1 = { employee_id: '' };
          } else {
            // Edit mode — now fetch edit data (EMPS is ready so getEmpName works)
            this.getcustomerschedulerAddEdit(this.scheduler_id);
          }
        },
        () => alert('Network Error loading form data')
      );
    }, error => { alert('Network Error params API'); });
  }

  setMinDateTime(dateStr?: string) {
    let now: Date;
    if (dateStr) {
      now = new Date(dateStr); // convert string to Date
    } else {
      now = new Date();
    }

    const year = now.getFullYear();
    const month = ('0' + (now.getMonth() + 1)).slice(-2);
    const day = ('0' + now.getDate()).slice(-2);
    const hours = ('0' + now.getHours()).slice(-2);
    const minutes = ('0' + now.getMinutes()).slice(-2);

    this.minDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
    return this.minDateTime; // <-- important if you are assigning
  }

  calcDuration() {
    this.model.duration_minutes = (this.durHours * 60) + this.durMins;
  }

  calcActiveDuration() {
    this.model.employee_active_minutes = (this.activeHours * 60) + this.activeMins;
  }

  calcRowDuration(i: number) {
    const r = this.serviceRows[i];
    r.duration_minutes = (r.durHours * 60) + r.durMins;
  }

  calcRowActive(i: number) {
    const r = this.serviceRows[i];
    r.employee_active_minutes = (r.activeHours * 60) + r.activeMins;
  }

  addServiceRow() {
    this.serviceRows.push(this.defaultRow());
  }

  removeServiceRow(i: number) {
    this.serviceRows.splice(i, 1);
  }

  addEmpToRow(i: number, event: any) {
    const empId = event.target.value;
    if (!empId) return;
    const row = this.serviceRows[i];
    if (!row.employeeIds.includes(empId)) row.employeeIds.push(empId);
    event.target.value = '';
  }

  removeEmp(rowIdx: number, empIdx: number) {
    this.serviceRows[rowIdx].employeeIds.splice(empIdx, 1);
  }

  getEmpName(empId: any): string {
    if (!this.EMPS) return empId;
    const emp = this.EMPS.find(e => String(e.id) === String(empId));
    return emp ? emp.f_name : empId;
  }

  setDurationFromMinutes(mins: number) {
    this.durHours = Math.floor(mins / 60);
    this.durMins = mins % 60;
    this.model.duration_minutes = mins;
  }

  setActiveDurationFromMinutes(mins: number) {
    this.activeHours = Math.floor(mins / 60);
    this.activeMins = mins % 60;
    this.model.employee_active_minutes = mins;
  }

  isPastDate(): boolean {
    // In edit mode, allow saving even if date is in the past
    if (this.scheduler_id) return false;
    const date = this.model.scheduled_date;
    if (!date || date === '0000-00-00 00:00:00') return false;
    return new Date(date) < new Date();
  }


  getcustomerschedulerAddEdit(scheduler_id) {
    this.showLoader = true;
    this.loginservice.getcustomerschedulerAddEdit(scheduler_id, this.currentUser).subscribe(data => {
      if (data['status'] == 'success') {
        this.model = data;

        // Fix scheduled_date format for datetime-local input
        if (data['scheduled_date'] && data['scheduled_date'] !== '0000-00-00 00:00:00'
            && data['scheduled_date'] !== '' && data['scheduled_date'] !== null) {
          const dt = data['scheduled_date'].replace(' ', 'T').slice(0, 16);
          this.model['scheduled_date'] = dt;
          this.setMinDateTime(dt);
        } else {
          this.setMinDateTime();
        }

        // Pre-fill customer typeahead display
        this.appSug = { f_name: data['f_name'] || '' };

        // Pre-fill employee — model1 set here, never overwritten again
        this.model1 = {
          employee_id:   data['employee_id']   || '',
          employee_name: data['employee_name'] || ''
        };

        // Pre-fill service row — use service_category_id so the <select> matches
        const dur    = parseInt(data['duration_minutes'])        || 60;
        const active = parseInt(data['employee_active_minutes']) || 0;

        // Resolve service_category_id: API may return it directly or we match by name
        let svcId = data['customer_description_id'] || data['service_category_id'] || '';
        if (!svcId && this.dataresult && data['customer_description']) {
          const match = this.dataresult.find(
            s => s.service_category === data['customer_description'] ||
                 String(s.service_category_id) === String(data['customer_description'])
          );
          if (match) svcId = match.service_category_id;
        }
        // Fallback: if customer_description is already a numeric id
        if (!svcId && data['customer_description'] && !isNaN(Number(data['customer_description']))) {
          svcId = data['customer_description'];
        }

        this.serviceRows = [{
          service:                 svcId,
          employeeIds:             [String(data['employee_id'])],
          durHours:                Math.floor(dur / 60),
          durMins:                 dur % 60,
          duration_minutes:        dur,
          activeHours:             Math.floor(active / 60),
          activeMins:              active % 60,
          employee_active_minutes: active
        }];

        this.setDurationFromMinutes(dur);
        this.setActiveDurationFromMinutes(active);

        if (data['file_name'] && data['file_name'] !== '' && data['file_temp_name'] && data['file_temp_name'] !== '') {
          this.uploads_name.inventory_manager_upload_path = {
            file_name:      data['file_name'],
            file_temp_name: data['file_temp_name'],
          };
        }
      }
      this.showLoader = false;
    }, error => {
      alert('Network Error getcustomerschedulerAddEdit API');
      this.showLoader = false;
    });
  }


  search = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .do(() => this.searching = true)
      .switchMap(term =>
        this.loginservice.getemployeeterm(term, 'customer_profile', this.currentUser)
          .do(() => this.searchFailed = false)
          .catch(() => {
            this.searchFailed = true;
            return Observable.of([]);
          }))
      .do(() => this.searching = false)
      .merge(this.hideSearchingWhenUnsubscribed)
  formatter = (x: { f_name: string }) => '';

  asignModel(n) {
    if (typeof n === 'object') {
      const prevDesc = this.model ? this.model['customer_description'] : '';
      this.model = n;
      this.Emp_Id = n.id;
      this.model['customer_id'] = n.id;
      // Only reset service if not editing
      if (!this.scheduler_id) {
        this.model['customer_description'] = '';
      } else {
        this.model['customer_description'] = prevDesc;
      }
    }
  }

  initVar() {
    this.appSug = { f_name: '' }
    this.model = {
      ...this.model,
      phone: '',
      // f_name: n,
      email: '',
      reffered_id: '',
      membership: '',
      resume_path: '',
      id: '',
      f_name: '',
      dob: '',
      joining_date: '',
      address: '',
      state: '',
      city: '',
      zip: '',
      treading: false,
      facial: false,
      laser: false,
      waxing: false,
      hair_treat: false,
      haircut: false,
      haircolor: false,
      smothening: false,
      straightening: false,
      pedicure: false,
      manicure: false,
      cut_file: false,
      tan: false
    };
  }


  savescheduler() {
    this.showLoader = true;
    if (this.scheduler_id) {
      // Single edit mode — use first service row
      this.model['scheduler_id']            = this.scheduler_id;
      this.model['duration_minutes']        = this.serviceRows[0].duration_minutes;
      this.model['employee_active_minutes'] = this.serviceRows[0].employee_active_minutes;
      this.model['customer_description']    = this.serviceRows[0].service || this.model['customer_description'];
      this.model['customer_description_id'] = this.serviceRows[0].service || this.model['customer_description_id'];
      const emp = { employee_id: this.serviceRows[0].employeeIds[0] || this.model1.employee_id };
      this.loginservice.savescheduler(this.model, emp, this.currentUser).subscribe(
        data => {
          if (data['status'] === 'success') {
            this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
            this.router.navigate(['/customer-scheduler-list']);
          } else {
            this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
          }
          this.showLoader = false;
        }, error => { alert('Network Error savescheduler API'); this.showLoader = false; });
    } else {
      // Multi-service: save each row as separate entry with shared group_id
      const groupId = this.generateGroupId();
      const saves = [];
      this.serviceRows.forEach(row => {
        const empIds = row.employeeIds.length > 0 ? row.employeeIds : [this.model1.employee_id];
        empIds.forEach(empId => {
          const payload = {
            ...this.model,
            customer_description:    row.service,
            duration_minutes:        row.duration_minutes || 60,
            employee_active_minutes: row.employee_active_minutes || 0,
            group_id:                groupId
          };
          saves.push({ payload, emp: { employee_id: empId } });
        });
      });
      // Save sequentially
      this.saveNext(saves, 0, groupId);
    }
  }

  saveNext(saves: any[], idx: number, groupId: string) {
    if (idx >= saves.length) {
      this.showLoader = false;
      this._flashMessagesService.show('Appointment saved!', { cssClass: 'alert-success' });
      this.router.navigate(['/customer-scheduler-list']);
      return;
    }
    const { payload, emp } = saves[idx];
    this.loginservice.savescheduler(payload, emp, this.currentUser).subscribe(
      data => {
        if (data['status'] === 'success') {
          this.saveNext(saves, idx + 1, groupId);
        } else {
          this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
          this.showLoader = false;
        }
      }, error => { alert('Network Error savescheduler API'); this.showLoader = false; });
  }

  generateGroupId(): string {
    return 'grp_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6);
  }


  upload(f, name) {
    if (this.model.id) {
      if (f.target.files[0]) {
        const formData = new FormData();
        formData.append(name, f.target.files[0]);
        this.formdata = formData;
        this.upname = name;
        this.targetfile = f.target.files[0];
        this.uploads_name.inventory_manager_upload_path = { file_name: f.target.files[0].name };
        this.model.resume_path = f.target.files[0].name;
      }
    } else {
      this._flashMessagesService.show('Please Choose Employee', { cssClass: 'alert-danger' });
    }

  }

  uploadmanager(formData, name, Emp_Id) {
    this.loginservice.uploadFile1(formData, name, Emp_Id, '', 'id', 'employee_profile').subscribe(r => {
      if (r['status'] === 'success') {
        var path_name = name + '_path';
        this.uploads_name[path_name] = r;
        this.model['resume_temp_path'] = r['resume_temp_path'];
        this.model['resume_path'] = r['file_name'];
        // this.router.navigate(['/inventory-manager']);
      } else {
        this._flashMessagesService.show(r['message'], { cssClass: 'alert-danger' });
        // this.router.navigate(['/inventory-manager']);
      }
    },
      error => {
        alert('Network Error uploadmanager API');
        this._flashMessagesService.show('Error in the Data/Server', { cssClass: 'alert-danger' });
        // this.router.navigate(['/inventory-manager']);
      });
  }



  onDateChanged(type, event: IMyDateModel): void {
    // date selected
    if (type === 'month') {
      this.model['getmonth'] = event;
    } else {
      this.model['getyear'] = event;
    }
  }

  deleteEmp(id) {
    if (confirm('Deleting of this Employee is done from the entire system')) {
      if (confirm('Are you sure want to delete')) {
        this.loginservice.deletEMP(id).subscribe(data => {
          this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
          this.movePreviousNext(this.model, 0)
        },
          error => {
            alert('Network Error Scheduler Delete API');
            this.showLoader = false;
          });
      }
    }
  }


  deleteupload() {
    if (confirm('Deleting of this record is done from the entire system')) {
      if (confirm('Are you sure want to delete')) {
        this.loginservice.deleteuploadEMP(this.model.id, 'id', 'employee_profile').subscribe(data => {
          this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
          this.uploads_name.inventory_manager_upload_path = {
            resume_path: '',
            resume_temp_path: '',
          };
          this.model['resume_path'] = '';
          this.model['resume_temp_path'] = '';
        },
          error => {
            alert('Network Error delete upload API');
            this.showLoader = false;
          });
      }
    }
  }


  movePreviousNext(modelVal, n) {
    this.showLoader = true;
    this.loginservice.movePreviousNextemp(modelVal, n, 'customer_profile', this.currentUser)
      .subscribe(
        data => {
          if (data['status'] == 'success') {
            this.model = data['comp_details'][0];
            this.Emp_Id = this.model.id;
          } else {
            this._flashMessagesService.show('No record found!', { cssClass: 'alert-danger' });
          }
          this.showLoader = false;
        },
        error => {
          alert('Network Error movePreviousNextemp API');
          this._flashMessagesService.show('No record found!', { cssClass: 'alert-danger' });
          this.showLoader = false;
        });

  }


  search1 = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .do(() => this.searching = true)
      .switchMap(term =>
        this.loginservice.getemployeeterm(term, 'employee_profile', this.currentUser)
          .do(() => this.searchFailed = false)
          .catch(() => {
            this.searchFailed = true;
            return Observable.of([]);
          }))
      .do(() => this.searching = false)
      .merge(this.hideSearchingWhenUnsubscribed)
  formatter1 = (x: { f_name: string }) => '';

  asignModel1(n) {

    if (typeof n === 'object') {
      this.model1 = n;
      this.model1['employee_id'] = n.id;
      this.model1['employee_name'] = n.f_name;
    } else {
      // this.initVar();
    }
  }

  initVar1() {
    this.appSug = {
      f_name: ''
    }
  }

  initVar2() {
    this.appSug1 = {
      f_name: ''
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/customer-schedular/customer-schedular.component.ts